export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavTitle',
        _children: ['会員情報'],
        _class: 'parent_tab'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'ダッシュボード',
        to: '/dashboard',
        icon: 'cil-speedometer',
      },
      {
        _name: 'CSidebarNavItem',
        name: '会員情報',
        to: '/profile',
        icon: 'cil-user-follow',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Eメール設定',
        to: '/email-settings',
        icon: 'cil-envelope-closed',
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['会員管理'],
        _class: 'parent_tab'
      },
      {
        _name: 'CSidebarNavItem',
        name: '会員シート打込み',
        to: '/members-card-add',
        icon: 'cil-plus',
      },
      {
        _name: 'CSidebarNavItem',
        name: '新規会員ID',
        to: '/new-member-id',
        icon: 'cil-plus',
      },
      {
        _name: 'CSidebarNavItem',
        name: '新規会員登録',
        to: '/member-add',
        icon: 'cil-user-follow',
      },
      {
        _name: 'CSidebarNavItem',
        name: '会員検索',
        to: '/member-search',
        icon: 'cil-magnifying-glass',
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['クーポン情報'],
        _class: 'parent_tab'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'クーポン登録',
        to: '/coupon-create',
        icon: 'cil-library-add',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'クーポン一覧',
        to: '/coupon-list/list',
        icon: 'cil-list',
      },
      {
        _name: 'CSidebarNavItem',
        name: '割引プラン一覧',
        to: '/discount-plan-list',
        icon: 'cil-pencil',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'クーポン操作',
        to: 'coupon-operation',
        icon: 'cil-gift',
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['ポイント情報'],
        _class: 'parent_tab'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'ポイント更新履歴',
        to: '/pointhistory',
        icon: 'cil-list',
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['お問合せ'],
        _class: 'parent_tab'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'お問合せ',
        to: '/inquiry',
        icon: 'cil-comment-square'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'お問合せ一覧',
        to: '/inquirylist',
        icon: 'cil-comment-square'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['お問合せ管理'],
        _class: 'parent_tab'
      },
      {
        _name: 'CSidebarNavItem',
        name: '顧客問合せ一覧',
        to: '/customerinquirylist',
        icon: 'cil-comment-square'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['ログアウト'],
        _class: 'parent_tab'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'ログアウト',
        to: '/logout',
        icon: 'cil-room'
      }
    ]
  }
]